import { api } from '../api';
import type { WorkSchedule, WorkScheduleFormData, WorkScheduleFilters, CreateMultipleWorkSchedulesData } from '../../../modules/timeclock/types/timeclock.types';

export const workScheduleService = {
  // Listar jornadas de trabalho
  list: async (filters?: WorkScheduleFilters) => {
    const params = new URLSearchParams();
    
    if (filters?.userId) params.append('userId', filters.userId);
    if (filters?.type) params.append('type', filters.type);
    
    const response = await api.get(`/work-schedules?${params.toString()}`);
    return response.data;
  },

  // Buscar jornadas por usuário
  findByUserId: async (userId: string) => {
    const response = await api.get(`/work-schedules/user/${userId}`);
    return response.data;
  },

  // Buscar jornada específica
  get: async (id: string) => {
    const response = await api.get(`/work-schedules/${id}`);
    return response.data;
  },

  // Criar nova jornada
  create: async (data: WorkScheduleFormData) => {
    const response = await api.post('/work-schedules/multiple', data);
    return response.data;
  },

  // Criar múltiplas jornadas
  createMultiple: async (data: CreateMultipleWorkSchedulesData) => {
    const response = await api.post('/work-schedules/multiple', data);
    return response.data;
  },

  // Atualizar jornada
  update: async (id: string, data: Partial<WorkScheduleFormData>) => {
    const response = await api.patch(`/work-schedules/${id}`, data);
    return response.data;
  },

  // Deletar jornada
  delete: async (id: string) => {
    const response = await api.delete(`/work-schedules/${id}`);
    return response.data;
  }
}; 